import { Component, OnInit,ElementRef, ViewChild  } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Observable, throwError } from 'rxjs';
import { Router,RouterLinkActive } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { ShareService } from '../../services/share.service';
import { faThinkPeaks } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('navheader', { read: ElementRef, static:false }) navheader: ElementRef;
  deviceInfo = null;
  isMobile :boolean;
  isDesktopDevice:boolean;
  isTablet:boolean;
  textSearch: string = '';
  textSearchResult: string = '';
  dataSearch: any[]=[];
  filteredDataSearch: any;
  isLoginStatus:boolean=false
  keyword = 'name';
  url : any;
  selectedCountry: any;
  constructor( private el: ElementRef,private deviceService: DeviceDetectorService, private apiService: ApiService,private router: Router,private keycloakService:KeycloakService,private shareService: ShareService) {
    this.epicFunction();
    this.isLogin()
   }

  ngOnInit(): void {
    this.url = this.router.url.split('/')[1];
    this.shareService.routerEvent.subscribe((res:any)=>{
      if(res !== ''){
        this.router.navigate([res])
      }
    })
  }
  toggleNav(){

    let classN = this.navheader.nativeElement.className;
    if (classN.includes('show')){
      this.navheader.nativeElement.classList.remove('show');
    }
    else{
      this.navheader.nativeElement.classList.add('show');
    }
  }
  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
     this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();

  }
  onChange(event){
    this.textSearch = event.target.value;

  }
  onChangeSearch(event: any) {


    let text = event.query;
    this.apiService.searchApi(text).pipe(
      catchError((err, caught) => {
        return throwError(err);
      })
    ).subscribe((res: any)=>{
      if(res.code == 'OK'){
        this.dataSearch=[];
        this.filteredDataSearch = [];
        let data = []
        for(let item of res.data.features){
          let dat = {
            geometry: item.geometry,
            name: item.properties.label,
            code: item.properties.smartcode,
            postCode: item.properties.postcode,
            properties: item.properties,
          }
          data.push(dat)
          this.filteredDataSearch.push(dat)
        }
        this.dataSearch = data;
      }
    })
  }

  onFocused(e) {
    console.log(e)
    // do something
  }
  selectEvent(e){
    let smartcode = e.code;
    // this.shareService.shareSearch(e);
    // localStorage.setItem('dataSearch', e);
    localStorage.setItem('shareData', JSON.stringify(e));

    this.router.navigate(['../map',smartcode]);
    console.log(`e`, e);
    
  }
  getDefaultLocation(){
    let defaultCode='110062VH24WM'
    this.router.navigate(['../map',defaultCode]);
  }
  isLogin(){
    this.keycloakService.getToken().then((data:any)=>{

      if (data =='') {

      }else{
        this.isLoginStatus=true
      }
    })

  }
  logOut(){
    this.keycloakService.logout()
  }
  async logIn() {
    const { keycloakConfig } = environment;
      await  this.keycloakService.init({
          config: keycloakConfig,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          },
          bearerExcludedUrls: [
            'main$'
          ]
        });
      }

}
